import { render, staticRenderFns } from "./SkillsGroup.vue?vue&type=template&id=1cf25178&scoped=true&"
import script from "./SkillsGroup.vue?vue&type=script&lang=ts&"
export * from "./SkillsGroup.vue?vue&type=script&lang=ts&"
import style0 from "./SkillsGroup.vue?vue&type=style&index=0&id=1cf25178&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf25178",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VChipGroup,VCol,VRow})
